import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs';

declare var $;

@Injectable()
export class PromptService {

  constructor(private zone: NgZone) { }

  //错误框
  public error(message: string, title: string = "") {
    return new Observable((observer) => {
      const successHandler = () => observer.next();

      $.kerror(message, title, () => {
        this.zone.run(() => {
          successHandler();
        });
      });
    });
  }
  //警告框
  public warning(message: string, title: string = "") {
    return new Observable((observer) => {
      const successHandler = () => observer.next();

      $.kwarning(message, title, () => {
        this.zone.run(() => {
          successHandler();
        });
      });
    });
  }
  //成功框
  public success(message: string, title: string = "") {
    return new Observable((observer) => {
      const successHandler = () => observer.next();

      $.ksuccess(message, title, () => {
        this.zone.run(() => {
          successHandler();
        });
      });
    });
  }
  //信息框
  public info(message: string, title: string = "") {
    return new Observable((observer) => {
      const successHandler = () => observer.next();

      $.kinfo(message, title, () => {
        this.zone.run(() => {
          successHandler();
        });
      });
    });
  }

  //确认框
  public confirm(message: string, title: string = "") {
    return new Observable((observer) => {
      const successHandler = (e) => observer.next(e);

      $.kconfirm(message, title, (isConfirm) => {
        this.zone.run(() => {
          successHandler(isConfirm);
        });
      });
    });
  }

  //toast
  public toast(message: string, time: number = 500) {
    $.ktoast(message, time);
  }

  //loading
  public showloading(message: string, clickClose: boolean = true) {
    return new Observable((observer) => {
      const successHandler = (e) => observer.next(e);

      $.kloading('show', {
        text: message,
        clickClose: clickClose,
        clb: () => {
          this.zone.run(() => {
            successHandler(null);
          });
        }
      });
    });
  }
  public closeloading() {
    $.kloading('hide');
  }
}
